import * as Yup from 'yup';

import type { buildGlobalRoleIdsSchema } from '../../UserRoles/schemas/global-role-ids.schema';

export const buildRolesSchema = (
  globalRoleIdsSchema: ReturnType<typeof buildGlobalRoleIdsSchema>,
) => Yup.object().shape({ globalRoleIds: globalRoleIdsSchema });
